import React from 'react';
import { ExitToApp } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { useMsal } from '@azure/msal-react';

const Logout: React.FC = () => {
  const { instance } = useMsal();
  const handleLogoutRedirect = () => {
    instance.logoutRedirect().catch((error) => console.log(error));
  };

  return (
    <IconButton onClick={handleLogoutRedirect}>
      <ExitToApp /> <span>{t('headerMenu.logout')}</span>
    </IconButton>
  );
};

export default Logout;
